export
const name: string = "Points";

export
const preproc: string = ``;

export
const declaration: string = `
    attribute vec3  a_position;
    attribute vec2  a_tex_coord;
    attribute float a_manipulation;

    #if !defined(PRIMITIVE_ID_PASS)
    attribute float a_visibility;
    #endif

    #if defined(PRIMITIVE_ID_PASS)
    attribute float a_primitive_id;
    #endif

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
    attribute float a_selection;
    #endif

    uniform   mat4  u_view_projection;
    uniform   mat4  u_manipulator;
    uniform   mat4  u_look_forward_projection;
    uniform   mat4  u_model_transformation; // this supply the model in model view projectionm matrix as we do not have per mesh model trafo, but met fat model

    uniform   float u_height_of_near_plane;
    uniform   float u_min_point_size;
    uniform   float u_max_point_size;
    uniform   vec2  u_pin_point;
    uniform   vec2  u_viewport;
    uniform   float u_viewport_scale;
`;

export
const varyings: string = `
    varying   vec2  v_tex_coord;

    #if defined(PRIMITIVE_ID_PASS)
    varying vec4        v_primitive_id;
    #endif

    #if !defined(DEPTH_PASS)
    varying   float v_selected;
    #endif
`;

export
const implementation: string = `
    void main(void)
    {
        v_tex_coord = a_tex_coord;

    #if defined(PRIMITIVE_ID_PASS)
       v_primitive_id = intToVec4(a_primitive_id);
    #endif

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
        v_selected  = a_selection;
    #endif

        float pointSize = 0.0;
        vec2 viewport = u_viewport * u_viewport_scale;

        vec4 position = vec4(a_position.xyz, 1.0);
    #ifdef MANIPULATOR_ENABLED
        if (a_manipulation > 0.5) {
            position = u_manipulator * position;
        }
    #endif
        pointSize = clamp((u_height_of_near_plane * u_max_point_size) / (u_view_projection * u_model_transformation * position).w, u_min_point_size, u_max_point_size);
        pointSize = pointSize * u_viewport_scale;

        if ((u_pin_point.x + u_pin_point.y) > 0.00001)
        {
            vec2 eye_space_offset;
            // determine window space position of input a_position
            vec4 clip_space = u_look_forward_projection * u_model_transformation * position;
            vec4 ndc_space  = clip_space / clip_space.w;

            vec2 window_space = ndc_space.xy * 0.5 + 0.5;   // transform from -1 .. 1 to 0 .. 1
            window_space.x = window_space.x * viewport.x; // transform from 0 .. 1 to 0 .. width
            window_space.y = window_space.y * viewport.y; // transform from 0 .. 1 to 0 .. height

            // determine window space position of input a_position with y value moved up by 1.0
            position = vec4(a_position.x, a_position.y + 1.0, a_position.z, 1.0);
    #ifdef MANIPULATOR_ENABLED
        if (a_manipulation > 0.5) {
            position = u_manipulator * position;
        }
    #endif
            vec4 clip_space_up = u_look_forward_projection * u_model_transformation * position;
            vec4 ndc_space_up  = clip_space_up / clip_space_up.w;

            vec2 window_space_up = ndc_space_up.xy * 0.5 + 0.5; // transform from -1 .. 1 to 0 .. 1
            window_space_up.x = window_space_up.x * viewport.x; // transform from 0 .. 1 to 0 .. width
            window_space_up.y = window_space_up.y * viewport.y; // transform from 0 .. 1 to 0 .. height

            float dist = abs(window_space_up.y - window_space.y);

            eye_space_offset.x = (pointSize * u_pin_point.x) / dist;
            eye_space_offset.y = (pointSize * u_pin_point.y) / dist;

            position = vec4(a_position + vec3(eye_space_offset.x, eye_space_offset.y, 0.0), 1.0);
    #ifdef MANIPULATOR_ENABLED
            if (a_manipulation > 0.5) {
                position = u_manipulator * position;
            }
    #endif
        }

    #ifdef CLIPPING_PLANE
        setVaryingsForCPlane(u_model_transformation * position);
    #endif

    #if defined(PRIMITIVE_ID_PASS)
        gl_Position = u_view_projection * u_model_transformation * position;
    #else // other passes
        gl_Position = u_view_projection * u_model_transformation * position * a_visibility;
    #endif

        gl_PointSize = pointSize;

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS) && defined(LOGDEPTH)
        setVaryingsForLogarithmicDepthBuffer();
    #endif
    }
`;
